import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { Specialty } from "../../../dto/specialty.dto";

export type userConfirm = 'Confirm' | 'Denied';
export type Adds = {
    procedure_id: number;
    procedure_name: string;
    obj: modalDate
};

export type modalDate = {
    addSpecialty?: {
        isAddSpecialty: boolean;
        list: Omit<Specialty, 'isActive'>[];
    }
    isEditProcedureValue?: {
        isPriceEdit: boolean;
        isTAmmountEdit: boolean;
        currentPrice: number;
        newPrice: number;
    }
}

@Component({
    template: `
    <div  class="content-container">
        <!-- Modal para confirmar a adição de especialidades no procedimento-->
        <div class="text" *ngIf="data.obj.addSpecialty !== null && data.obj.addSpecialty?.isAddSpecialty;">
            <span>
                Você está prestes a adicionar as seguintes especialidades:
            </span>
            <br />
            <br />
            <div *ngIf="data.obj.addSpecialty.list?.length > 0" class="d-flex flex-column">
                <span *ngFor="let n of data.obj.addSpecialty.list">
                    - <strong>{{ n.name }}</strong>
                </span>
            </div>
            <br />
            <span>No procedimento <strong>{{ data.procedure_name }}</strong>.</span>
            <br /><br />
        </div>
        <!-- Modal para confirmar a alteração de price/valor do procedimento-->
        <div *ngIf="data.obj.isEditProcedureValue !== null && data.obj.isEditProcedureValue?.isPriceEdit && !data.obj.isEditProcedureValue.isTAmmountEdit">
            <div class="change-value">
                <span>
                    Você está prestes a alterar o valor do procedimento 
                    <strong style="font-size: 18px;">{{data.procedure_name}}</strong> <br/> 
                    de <strong>{{data.obj.isEditProcedureValue.currentPrice | currency}}</strong> 
                    para <strong>{{data.obj.isEditProcedureValue.newPrice | currency}}</strong>. 
                </span>
                <br />
                <span>Você confirma essa alteração ?</span>
            </div>
            <br />
            <br />
        </div>
        <!-- Modal para confirmar a alteração de TRANSFER_AMMOUNT/valor de repasse do procedimento-->
        <div *ngIf="data.obj.isEditProcedureValue !== null && !data.obj.isEditProcedureValue?.isPriceEdit && data.obj.isEditProcedureValue?.isTAmmountEdit">
            <div class="change-value">
                <span>
                    Você está prestes a alterar o valor de repasse do procedimento 
                    <strong style="font-size: 18px;">{{data.procedure_name}}</strong> <br/>
                    de <strong>{{data.obj.isEditProcedureValue?.currentPrice | currency}}</strong> 
                    para <strong>{{data.obj.isEditProcedureValue?.newPrice | currency}}</strong>.
                </span>
                <br />
                <span>Você confirma essa alteração ?</span>
            </div>
            <br />
            <br />
        </div>

        <div class="actions-container">
            <button mat-button (click)="onConfirm()" class="btn-primary">
                Confirmar
            </button>

            <button mat-button (click)="onDeny()">
                Cancelar
            </button>
        </div>
    </div>
    `,
    styles: [
        `
        .change-value{
            display: flex;
            flex-direction: column;
            min-height: 75px;
        }
        `
    ],
})
export class addSpecialtyChangePricesModal {
    private readonly userResponseSubject = new Subject<userConfirm>();
    readonly response$ = this.userResponseSubject.asObservable(); 
    constructor(
        public dialog: MatDialogRef<addSpecialtyChangePricesModal>,
        @Inject(MAT_DIALOG_DATA) public data: Adds
    ) {}

    onDeny() {
        this.userResponseSubject.next('Denied');
        this.dialog.close();
    }
    
    onConfirm() {
        this.userResponseSubject.next('Confirm');
        this.dialog.close()
    }
}